import createClient from '../../apolloClient';
import MUTATION_RESEND_VERIFICATION_CODE from '../../mutation/resendVerificationCode';

const handleResendVerificationCode = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_RESEND_VERIFICATION_CODE,
    variables,
  });
  const { resendVerificationCode } = result?.data || {};
  return resendVerificationCode;
};

export default handleResendVerificationCode;
